export default "__VITE_ASSET__DLt5pL$z__"